import { BaseService } from "../../base-service";

export interface Organization {
    id:string;
    name:string;
}

class OrganizationApi {
    async getUserOrganization() {
        const path = `/api/v1/organisation/user-organisation`;
        let response = await BaseService.AsyncGet(path);
        return response as Organization[];
    }
}
const organizationService = new OrganizationApi();

export { organizationService };